'use strict';

export default {
  devStoreConfig: false,
  api: {
    default: 'https://stormy-island-38503.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: false,
  }
};



// WEBPACK FOOTER //
// ./config/config.client7.js